import React, { useState, useEffect } from "react";
import { ChakraProvider } from '@chakra-ui/react';
import './App.css';

import AppRoutes, { UnauthorizedRoutes } from '../Routes';
import { authenticate } from "../APIs";
import { AuthContext } from "../Library/contexts";
import EventEmitter from "../Library/EventEmitter";
import { useLocation } from "react-router-dom";
import { getItemFromLocalStorage } from "../Library/helpers";
import PATHS from "../Routes/paths";
import { LottieView } from "../Components/Atoms";
import skeletonLottie from "../Assets/images/jsons/skeletonLottie.json"
import skeletonLottieLight from "../Assets/images/jsons/skeletonLottieLight.json"
import { AJJAS_APP_THEMES } from "../Library/constants";

function App() {
  const [ isLoading, setIsLoading ] = useState(true);
  const [ authenticated, setAuthenticated ] = useState(null);
  const searchParamas = new URLSearchParams(window.location.search);
  const location = useLocation();

  useEffect(() => {
    if (!global.EE) global.EE = new EventEmitter();

    let hostname = window.location.hostname.split(".");
    if (hostname && hostname.length) hostname = hostname[0];

    authenticate((error, data) => {
      if (data.message) {
        if (global.WS && global.WS.wsConnected) {
          global.WS.closeSocket();
          global.WS = null;
        }

        if (global.UWS && global.UWS.wsConnected) {
          global.UWS.closeSocket();
          global.UWS = null;
        }
      }

      setAuthenticated(data);
      setIsLoading(false);

      if (data) {
        if (data.profile) {
          if (data.profile.accessCodes) {
            window.localStorage.setItem("accessCodes", JSON.stringify(data.profile.accessCodes));
          }
          if (data.profile.des) window.localStorage.setItem("des", data.profile.des);
          if (data.profile.user) window.localStorage.setItem("user", true);
          else window.localStorage.removeItem("user");

          if (data.profile.fn) window.localStorage.setItem("fn", data.profile.fn);
          if (data.profile.uh) window.localStorage.setItem("uh", data.profile.uh);

          if (data.profile.rly) window.localStorage.setItem("relay", data.profile.rly);
          else window.localStorage.removeItem("relay");

          if (data.profile.rlyCntrl) window.localStorage.setItem("relayControl", data.profile.rlyCntrl);
          else window.localStorage.removeItem("relayControl");
        } else if (data.assets) {
          if (data.assets.user) window.localStorage.setItem("user", true);
          else window.localStorage.removeItem("user");
        }
        if (getItemFromLocalStorage("theme") && !window.localStorage.getItem("user")) document.body.classList.add("Ev-Light-Theme-Container");
        else document.body.classList.remove("Ev-Light-Theme-Container");
      }
    });
  }, [ location.pathname ]);

  const setProfile = (profile) => {
    setAuthenticated((old) => ({ ...old, profile }));
  };

  useEffect(() => {
    if (!authenticated) return;

    let isPaused = null;

    const toggleReconnect = (next, client) => {
      if (next) client?.pauseReconnect();
      else client?.resumeReconnect();
    }

    const setPaused = (next) => {
      if (isPaused === next) return;
      isPaused = next;

      toggleReconnect(next, global.UWS);
      if (!authenticated?.profile?.user) toggleReconnect(next, global.WS);
    };

    const handleVisibilityChange = () => setPaused(document.visibilityState === "hidden");

    setPaused(document.visibilityState === "hidden");

    document.addEventListener("visibilitychange", handleVisibilityChange);

    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, [authenticated]);

  if (isLoading) {
    if (searchParamas.get("fromApp")) {
      const isAmber = searchParamas.get("themeName") === AJJAS_APP_THEMES.AMBER;
      const animationData = isAmber ? skeletonLottie : skeletonLottieLight;
      const className = "app-lottie-view " + (isAmber ? "" : "app-lottie-view-light-bg");

      return <LottieView animationData={animationData} className={className} />;
    }
    else return <div>Loading</div>;
  }

  return (
    <ChakraProvider>
      <AuthContext.Provider value={{ ...authenticated, setProfile }}>
        {authenticated && authenticated.profile ? <AppRoutes user={!!authenticated.profile.user} codes={authenticated.profile.accessCodes} /> : <UnauthorizedRoutes />}
      </AuthContext.Provider>
    </ChakraProvider>
  );
}

export default App;
